module.exports = __webpack_public_path__ + "8b0857db7117783c5f7264381d1f7664.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/NonAuthHomePage/components/Banner/components/Background/images/bigWave.svg
// module id = PO1/
// module chunks = 13